import { observer } from 'mobx-react-lite'
import { useMemo, useState } from 'react'
import { type ITabItem, Scrollbar, Tabs } from 'shared/ui'
import styles from './styles.module.scss'
import { TriggerTab } from './TriggerTab'
import { InstructionsTab } from './InstructionsTab'
import { SettingsTab } from './SettingsTab'

enum UnifiedTabsEnum {
  Trigger = 'trigger',
  Instructions = 'instructions',
  Settings = 'settings',
}

const TABS: ITabItem<UnifiedTabsEnum>[] = [
  {
    key: UnifiedTabsEnum.Trigger,
    name: 'Trigger',
  },
  {
    key: UnifiedTabsEnum.Instructions,
    name: 'Instructions',
  },
  {
    key: UnifiedTabsEnum.Settings,
    name: 'Settings',
  },
]

export const UnifiedTabs = observer(() => {
  const [activeTab, setActiveTab] = useState(UnifiedTabsEnum.Trigger)
  const TabContent = useMemo(() => {
    switch (activeTab) {
      case UnifiedTabsEnum.Trigger:
        return TriggerTab
      case UnifiedTabsEnum.Instructions:
        return InstructionsTab
      case UnifiedTabsEnum.Settings:
        return SettingsTab
      default:
        return () => null
    }
  }, [activeTab])

  const activateTab = (tab: ITabItem<UnifiedTabsEnum>) => setActiveTab(tab.key)

  return (
    <>
      <Tabs
        tabs={TABS}
        activeTabKey={activeTab}
        handleSelectTab={activateTab}
        tabsClassName={styles.tabs}
        isDefaultOverflow
      />
      <Scrollbar indentX={14}>
        <TabContent />
      </Scrollbar>
    </>
  )
})
